export const useDatadogUser = () => {
    const { setUser } = useDatadog()
    const customerStore = useCustomerStore()
    const { customer } = storeToRefs(customerStore)
    const { $fingerprintId } = useFingerprint()

    if (import.meta.client) {
        watchEffect(() => {
            // Conditional setUser
            if (customer?.value) {
                setUser({
                    id: $fingerprintId as string,
                    name: `${customer.value.firstName} ${customer.value.lastName}`.trim(),
                    email: customer.value?.email,
                    // TODO(better-auth): this is a Magento/ACCS id. In the future, also tag
                    // the canonical Better Auth / app-level user id for observability.
                    magento_id: customer.value?.id,
                })
            } else {
                setUser({ id: $fingerprintId as string }) // Guest
            }
        })
    }
}
